export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M16 0C7.188 0 0 6.628 0 14.758c0 4.377 2.09 8.486 5.72 11.31V34l8.69-4.556c.57.054 1.089.072 1.59.072 8.812 0 16-6.629 16-14.758C32 6.628 24.812 0 16 0zm8.76 19.135c0 .59-.466 1.072-1.037 1.072-.207 0-.414-.071-.604-.197l-2.367-1.768v.554c0 .786-.605 1.411-1.365 1.411H9.382c-.76 0-1.365-.643-1.365-1.411v-6.968c0-.787.605-1.412 1.365-1.412h10.005c.76 0 1.365.643 1.365 1.412v.554l2.367-1.77c.173-.124.38-.196.605-.196.57 0 1.036.483 1.036 1.072v7.647z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "34",
    "fill": "#1371C8",
    "viewBox": "0 0 32 34"
  }
};